import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const StressLogPage = lazy(() => import("./StressLogPage.tsx"));

const StressLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StressLogPage />
    </Suspense>
  );
};

export default StressLogPageLazy;
